function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { View } from "react-native";
import { useBiblo } from "../../hooks/Biblo.hook";
import { ReaderItem } from "./ReaderItem.component";
import { Separator as DefaultSeparator } from "../Separator.component";
import { ReaderHeader } from "./ReaderHeader.component";
import { PropsProvider } from "../../hooks/Props.hook";
import { ItemPropsProvider } from "../../hooks/ItemProps.hook";
export const ReaderList = /*#__PURE__*/React.memo(_ref => {
  let {
    file
  } = _ref;
  const {
    readerOptions,
    disableDefaultStyles: disableDefaultStylesGlobal
  } = useBiblo();
  const {
    items,
    ...bio
  } = file;
  const disableDefaultStyles = disableDefaultStylesGlobal || readerOptions.disableDefaultStyles;
  const disableFooterSeparator = readerOptions.footerSeparatorHidden || !readerOptions.footerStyle && !readerOptions.footerComponent;
  const Footer = readerOptions.footerComponent || View;
  const Separator = readerOptions.separator || (props => /*#__PURE__*/React.createElement(DefaultSeparator, _extends({
    disableDefaultStyles: disableDefaultStyles
  }, props)));
  return /*#__PURE__*/React.createElement(PropsProvider, {
    props: bio.props,
    propTypes: bio.propTypes
  }, /*#__PURE__*/React.createElement(ReaderHeader, {
    bio: bio
  }), items.map((item, index) => /*#__PURE__*/React.createElement(View, {
    key: index
  }, (index > 0 || !readerOptions.headerSeparatorHidden) && /*#__PURE__*/React.createElement(Separator, {
    index: index - (readerOptions.headerSeparatorHidden ? 1 : 0),
    isFirst: index === (readerOptions.headerSeparatorHidden ? 1 : 0),
    isLast: disableFooterSeparator ? index === items.length - 1 : false,
    style: readerOptions.separatorStyle
  }), /*#__PURE__*/React.createElement(ItemPropsProvider, {
    props: item.component.props,
    propTypes: item.component.propTypes
  }, /*#__PURE__*/React.createElement(ReaderItem, {
    index: index,
    isFirst: index === 0,
    isLast: index === items.length - 1,
    Component: item.component,
    props: {
      ...bio.props,
      ...item.component.props
    },
    Wrapper: item.component.wrapper || bio.wrapper,
    wrapperStyle: [bio.wrapperStyle, item.component.wrapperStyle],
    title: item.component.title === "" ? null : item.component.title || item.title,
    originalTitle: item.originalTitle,
    description: item.component.description,
    bio: bio
  })))), disableFooterSeparator || /*#__PURE__*/React.createElement(Separator, {
    index: items.length,
    isFirst: false,
    isLast: true
  }), /*#__PURE__*/React.createElement(Footer, {
    bio: bio,
    style: readerOptions.footerStyle
  }));
});
ReaderList.displayName = "ReaderList";
//# sourceMappingURL=ReaderList.component.js.map